
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Hero = () => {
  return (
    <section className="relative py-12 md:py-20 overflow-hidden bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row gap-8 items-center">
          {/* Left Content */}
          <div className="w-full lg:w-1/2">
            <div className="text-sm text-blue-600 font-medium mb-3">Your Global Opportunity Navigator</div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              <span className="text-gray-800">Opening Doors</span>
              <br />
              <span className="text-blue-600">Worldwide</span>
            </h1>
            <p className="text-gray-600 mb-8 max-w-xl">
              Find visa-sponsored jobs, ace IELTS & TOEFL exams, access detailed country guides, 
              and navigate top university admissions with our comprehensive platform designed 
              for global achievers.
            </p>
            <Link to="/tools">
              <Button 
                variant="secondary" 
                className="rounded-md flex items-center gap-2 bg-blue-600 hover:bg-blue-700 px-6 hover:scale-105 transition-all duration-300"
              >
                Get Started Today
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 12L12 4M12 4H5M12 4V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Button>
            </Link>
          </div>
          
          {/* Right Content with Circular Images */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative h-[400px]">
              {/* Main Center Circle */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="relative">
                  <div className="w-[200px] h-[200px] bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
                </div>
              </div>
              
              {/* Top Circle - Woman with curly hair in window seat on a plane */}
              <div className="absolute top-0 right-[30%]">
                <div className="relative">
                  <div className="w-[160px] h-[160px] bg-blue-200 rounded-full overflow-hidden animate-float">
                    <img 
                      src="/lovable-uploads/bde2328d-b33a-4f3d-8d79-f5e10290a819.png" 
                      alt="Woman with curly hair sitting in window seat on a plane" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
              
              {/* Bottom Circle - Travel Planning Flat Lay */}
              <div className="absolute bottom-0 right-[10%]">
                <div className="relative">
                  <div className="w-[180px] h-[180px] bg-red-200 rounded-full overflow-hidden animate-float" style={{ animationDelay: "0.5s" }}>
                    <img 
                      src="/lovable-uploads/4b9e6694-829c-449a-bf3c-83d141316b7c.png" 
                      alt="Travel planning flat lay with airplane model, passport and money" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
              
              {/* Audio Wave Decoration */}
              <div className="absolute bottom-[20%] left-[20%]">
                <div className="bg-white p-2 rounded-full shadow-lg">
                  <div className="flex items-center gap-1 h-8 w-24">
                    {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                      <div 
                        key={i} 
                        className="w-1.5 bg-orange-500 rounded-full animate-pulse" 
                        style={{ 
                          height: `${Math.sin(i / 2) * 20 + 10}px`,
                          animationDelay: `${i * 0.1}s`
                        }}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Top Stat Counter */}
              <div className="absolute top-[15%] right-[5%] bg-white px-4 py-2 rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105">
                <p className="font-bold text-gray-800">190+</p>
                <p className="text-xs text-gray-500">Countries</p>
              </div>
              
              {/* Additional Stat Counter - Jobs */}
              <div className="absolute top-[60%] left-[10%] bg-white px-4 py-2 rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105" style={{ animationDelay: "0.3s" }}>
                <p className="font-bold text-gray-800">1 Million +</p>
                <p className="text-xs text-gray-500">Visa Sponsored Listings</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
